import React from 'react';
import { BinStatus } from '../types/bin/binStatus';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { instanceToPlain } from 'class-transformer';

export interface BinStatusContextProps {
  binStatuses: Map<string, BinStatus>;
  setBinStatuses: (binStatuses: Map<string, BinStatus>) => void;
  binStatusesLoading: boolean;
}

const defaultContext: BinStatusContextProps = {
  binStatuses: new Map(),
  setBinStatuses: () => {},
  binStatusesLoading: true,
};

export const BinStatusContext = React.createContext<BinStatusContextProps>(defaultContext);

interface BinStatusState {
  items: Record<string, any>[];
  loading: boolean;
}

export const binStatusSlice = createSlice({
  name: 'binStatus',
  initialState: { items: [], loading: true } as BinStatusState,
  reducers: {
    reset: state => {
      state.items = [];
      state.loading = true;
    },
    set: (state, action: PayloadAction<BinStatus[]>) => {
      state.items = action.payload.map(p => instanceToPlain(p));
    },
    add: (state, action: PayloadAction<BinStatus[]>) => {
      const map = new Map([...state.items, ...action.payload.map(p => instanceToPlain(p))].map(pmd => [pmd.id, pmd]));
      state.items = [...map.values()];
    },
    delete: (state, action: PayloadAction<BinStatus[]>) => {
      const idsToDelete = new Set(action.payload.map(bs => bs.id));
      state.items = [...state.items.filter(bs => !idsToDelete.has(bs.id))];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});
